import { registerApplication } from "single-spa";
import { MFEConfigs, RegisterableApplication } from "../models/Models";
import {
  determineActiveWhen,
  determineCustomProps,
  importModule,
} from "./microFrontendRegistrationUtilities";

export const registerMicrofrontend = (
  app: RegisterableApplication,
  mfeConfigs: MFEConfigs
): void => {
  registerApplication({
    name: app.name,
    app: importModule(app.name),
    activeWhen: determineActiveWhen(app),
    customProps: determineCustomProps(app, mfeConfigs),
  });
};
